module.exports = __webpack_public_path__ + "static/img/ttMerchant.58abf32e.png";